import React, { useEffect, useState } from "react";
import api from "utils/apiService";
import { AdminsColumn } from "data/AdminsColumn";
import { useSearchParams } from "react-router-dom";
import CheckTable from "components/CheckTable";
import CreateAdmin from "./components/CreateAdmin";

const Admins = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const fetchData = async () => {
    try {
      const res = await api.get(
        `/users/admins?page=${page}${search ? `&name=${search}` : ""}`
      );
      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, search]);

  return (
    <section className="mt-3">
      <CheckTable
        columnsData={AdminsColumn(fetchData)}
        tableData={data?.data}
        title="المسؤولين"
        loading={loading}
        extraComponent={<CreateAdmin refetch={fetchData} />}
        totalCount={data?.pagination?.totalDocs}
        searchExtra
      />
    </section>
  );
};

export default Admins;
